export class ScreeningQuestionCategory {
  id?: number;
  version?: number;
  name: string;
  description: string;
  orgId?: number;
}
